//import 'bootstrap';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

function ppCarouselInit(selector,nr)
{

    let items = document.querySelectorAll(selector);

    if(items.length<1) return;

    let itemsPerPage;
    itemsPerPage = (items.length<4) ? items.length : 4;

    items.forEach((el) => {
        const minPerSlide = nr;
        let next = el.nextElementSibling;
        el.classList.add('item-per-page_' + itemsPerPage );
        let itemClone;
        for (var i=1; i<minPerSlide; i++) {
            if (!next) {
                // wrap carousel by using first child
                next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            itemClone = el.appendChild(cloneChild.children[0])
            itemClone.classList.add('clone_'+i);
            next = next.nextElementSibling
        }
    });

}
ppCarouselInit('.pp-carousel-s2 .carousel .carousel-item',4);
ppCarouselInit('.bsct-pp-cpt-rotator-v2.nowosci .carousel .carousel-item',3);
ppCarouselInit('.bsct-pp-cpt-rotator-v2.wydawnictwa-regionalne .carousel .carousel-item',3);
ppCarouselInit('.bsct-pp-cpt-rotator .carousel .carousel-item',3);
ppCarouselInit('.bsct-pp-titlelead-slider .carousel .carousel-item',4);
ppCarouselInit('.pp-carousel-shop-card .carousel .carousel-item',3);
ppCarouselInit('.pp-carousel-m2 .carousel .carousel-item',4);
